import { useContext, useEffect, useState } from 'react'

import { SL_Modal } from '../../components/modal/Modal'
import { ModalTitle } from './components/ModalTitle'
import { ChoseCentral } from './components/ChoseCentral'
import { ReportTable } from './components/ReportTable'
import { ActionReportModal } from './ActionReportModal'

import { GeneralContext } from '../../context/GeneralContext/GeneralContext'
import { displayMessage } from '../../helpers/messages'
import { colors } from '../../services/style'
import api from '../../services/api'

export const AlertMonitoringModal = ({ onClose }) => {
    const { windowHeight, windowWidth } = useContext(GeneralContext)
    const [actions, setActions] = useState(null)
    const [central, setCentral] = useState(null)
    const [openReport, setOpenReport] = useState(null)

    const [showMore, setShowMore] = useState(true)
    const [showLoading, setShowLoading] = useState(false)

    const modalHeigth = windowHeight * 0.7
    const limit = 10

    const columns = [
        {
            dataIndex: 'button',
            title: '',
            width: 70,
            ellipsis: true,
            noExport: true,
            custom_render: (record) => {
                return (
                    <span className="rounded-[5px] text-medium last-alerts-alert-data-button normal-case cursor-pointer" style={{ border: `1px solid ${colors['sl-gray'][150]}` }} onClick={() => setOpenReport(record)}>
                        {displayMessage("OPEN")}
                    </span>
                )
            },
        },
        {
            dataIndex: 'type_description',
            title: displayMessage('DESCRIPTION'),
            width: 300,
            ellipsis: true,
        },
        {
            dataIndex: 'name',
            title: displayMessage('ALERT_NAME'),
            width: 300,
            ellipsis: true,
        },
        {
            dataIndex: 'device_name',
            title: displayMessage('DEVICE_NAME'),
            width: 300,
            ellipsis: true,
        },
        {
            dataIndex: 'sector',
            title: displayMessage('ZONE_NAME'),
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'location',
            title: displayMessage('LOCATION_DESCRIPTION'),
            width: 240,
            ellipsis: true,
        },
        {
            dataIndex: 'painel_date',
            title: displayMessage('ALERT_DATE'),
            width: 200,
            ellipsis: true,
        },
    ]

    const getReportData = async (params, id = central) => {
        setShowLoading(true)
        try {
            params = {
                ...params,
                limit,
                offset: params?.offset || 0,
                painel: true,
            }
            const { data } = await api.monitorings.reportsByCentral(id, params)

            setActions((current) => (!current ? data : current.concat(data)))
            if (limit > data.length) {
                setShowMore(false)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    useEffect(() => {
        if (central) {
            setActions(null)
            setShowMore(true)
            getReportData(null, central)
        }
    }, [central])

    return (
        <>
            {openReport && <ActionReportModal report={openReport} onClose={() => setOpenReport(null)} />}
            <SL_Modal
                open={!openReport}
                title={<ModalTitle onCloseButtonClick={onClose} title={displayMessage('ALERT_MONITORING_TITLE')} data={actions} columns={columns} />}
                closable={false}
                closeIcon={null}
                footer={null}
                width={windowWidth * 0.9}
                bodyStyle={{
                    height: modalHeigth,
                    padding: '2.22vh',
                }}
            >
                <ChoseCentral onChangeCentral={setCentral} />
                <ReportTable columns={columns} data={actions} height={modalHeigth - 200} onShowMore={getReportData} showMoreOptions={showMore} loading={showLoading} limit={limit} />
            </SL_Modal>
        </>

    )
}
